import React, { useEffect } from 'react';
import {
  Box,
  Container,
  AppBar,
  Toolbar,
} from '@mui/material';
import { useAppContext } from '../context/AppContext';
import LandingPage from '../components/LandingPage';
import OTPInputCard from '../components/OtpVerification';
import { BRANDING } from '../appConfig';

const AuthPage = () => {
  const { state, actions } = useAppContext();

  useEffect(() => {
    document.title = state.otpSent
      ? `Verify Phone | ${BRANDING.companyName}`
      : `Register for Asset Allocation | ${BRANDING.companyName}`;
  }, [state.otpSent]);

  const handleProceed = (action, userData) => {
    if (action === 'proceed') {
      // Send OTP and update state with user data
      actions.sendOTP(userData);
    }
  };

  const handleOTPVerify = (response) => {
    // OTP verification successful
    actions.verifyOTP();
  };

  const handleOTPResend = () => {
    return state.phoneNumber;
  };

  const handleBackToLanding = () => {
    // Reset OTP state and go back to landing
    actions.setAuthState({ 
      otpSent: false,
      // Keep user data for convenience
      // clientName: '',
      // email: '',
      // phoneNumber: ''
    });
  };

  return (
    <Box sx={{ flexGrow: 1, height: '100vh', display: 'flex', flexDirection: 'column' }}>
      <a href="#main-content" style={{ position: 'absolute', top: '-40px', left: '0', backgroundColor: '#000', color: '#fff', padding: '8px', zIndex: 100 }} onFocus={(e) => e.target.style.top = '0'} onBlur={(e) => e.target.style.top = '-40px'}>
        Skip to main content
      </a>
      {/* AppBar */}
      <AppBar position="static" sx={{ backgroundColor: '#000000' }}>
        <Toolbar>
          <a href={BRANDING.websiteUrl} target='_blank' rel="noopener noreferrer">
            <img
              src={BRANDING.logoPath}
              alt={BRANDING.logoAlt}
              style={{ height: 20, marginRight: 30 }}
            />
          </a>
          {/* <Typography 
            variant="h6" 
            component="div" 
            sx={{ fontSize: { xs: '1rem', sm: '1.25rem' } }}
          >
            Plan Your Goals
          </Typography> */}
        </Toolbar>
      </AppBar>

      {/* Main Content */}
      <Container id="main-content" sx={{
        // flexGrow: 1,
        py: 2,
        // display: 'flex',
        // flexDirection: 'column',
        // gap: 2,
        // overflow: 'auto',
        width: { sm: '100%', md: '30%' },
        // alignItems: 'center',
        // justifyContent: 'center'
      }}>
        <h1 className="sr-only">Register for Asset Allocation with Marcellus</h1>
        {!state.otpSent ? (
          <LandingPage
            onChange={handleProceed}
          />
        ) : (
          <OTPInputCard
            phoneNumber={state.phoneNumber}
            onVerify={handleOTPVerify}
            onResend={handleOTPResend}
            onBack={handleBackToLanding}
          />
        )}
      </Container>
    </Box>
  );
};

export default AuthPage;
